import { render, staticRenderFns } from "./WorkflowStats.vue?vue&type=template&id=71e3118c"
import script from "./WorkflowStats.vue?vue&type=script&lang=js"
export * from "./WorkflowStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports